// Copyright (c) 2016 Deere & Company

import Transfer, {getDefaultState as getTransferDefaultState} from '@deere/cps-it.warranty-model-factory/lib/transfer';

const NewTransfer = Transfer;

export const getDefaultState = () => getTransferDefaultState();

export default NewTransfer;



// WEBPACK FOOTER //
// ./src/product/new-transfer/state/new-transfer.js